import { ExpandMoreRounded, TrendingUpRounded } from "@mui/icons-material";
import { Button, Divider, Menu, MenuItem, Stack } from "@mui/material";
import { useState } from "react";
import {
  AddExistingMetricModal,
  CreateMetricModal,
  ItemProperty,
  LineGraphSkeleton,
  MetricPropertyMetric,
} from "src/components";
import { useGetMetricCollection } from "src/http";

interface Props {
  metricCollectionGuid: string | null;
  disabled: boolean;
  userCanEdit: boolean;
  onMetricAdded: (metricGuid: string) => void;
  onMetricRemoved: (metricGuid: string) => void;
}

const MetricProperty = (props: Props) => {
  const { data, isLoading } = useGetMetricCollection(props.metricCollectionGuid);
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);
  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false);
  const [isAddExistingModalVisible, setIsAddExistingModalVisible] = useState(false);

  return (
    <ItemProperty label="Metric" labelIcon={<TrendingUpRounded />}>
      {props.metricCollectionGuid != null && isLoading && <LineGraphSkeleton />}

      {data && data.length > 0 && (
        <Stack spacing={1} divider={<Divider variant="dashed" />} sx={{ mb: 1 }}>
          {data?.map((metric, i) => (
            <MetricPropertyMetric
              key={i}
              metric={metric}
              userCanEdit={props.userCanEdit}
              disabled={props.disabled}
              onRemoveMetricClicked={props.onMetricRemoved}
            />
          ))}
        </Stack>
      )}

      {(props.metricCollectionGuid == null || data?.length === 0) && props.userCanEdit && (
        <Button
          variant="tertiary"
          disabled={props.disabled}
          endIcon={<ExpandMoreRounded />}
          onClick={(e) => setMenuAnchor(e.currentTarget)}
        >
          Add Metric
        </Button>
      )}

      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={() => {
          setMenuAnchor(null);
        }}
      >
        <MenuItem
          onClick={() => {
            setMenuAnchor(null);
            setIsCreateModalVisible(true);
          }}
        >
          New
        </MenuItem>
        <MenuItem
          onClick={() => {
            setMenuAnchor(null);
            setIsAddExistingModalVisible(true);
          }}
        >
          Existing
        </MenuItem>
      </Menu>

      <CreateMetricModal
        visible={isCreateModalVisible}
        onAdded={(metricGuid) => {
          setIsCreateModalVisible(false);
          props.onMetricAdded(metricGuid);
        }}
        onCancelled={() => setIsCreateModalVisible(false)}
      />

      <AddExistingMetricModal
        visible={isAddExistingModalVisible}
        onAdded={(metricGuid) => {
          setIsAddExistingModalVisible(false);
          props.onMetricAdded(metricGuid);
        }}
        onCancelled={() => setIsAddExistingModalVisible(false)}
      />
    </ItemProperty>
  );
};

export { MetricProperty };
